import React from 'react';
import Modal from '../elements/Modal';
import { Server } from '../../server/server';

interface ConvertToForumModalProps {
  onClose: Function;
  onConvert: Function;
}

interface ConvertToForumModalState {
  forums: any[];
  selectedForumId: string;
  loading: boolean;
}

class ConvertToForumModal extends React.Component<ConvertToForumModalProps, ConvertToForumModalState> {
  constructor(props: ConvertToForumModalProps) {
    super(props);
    this.state = {
      forums: [],
      selectedForumId: '',
      loading: true
    };
  }

  async componentDidMount() {
    await this.loadForums();
  }

  async loadForums() {
    try {
      // Try to get forums from cache first
      let forums = await Server.forums.getForumsCache();
      
      if (!forums) {
        // If cache is null, get from server
        this.setState({ loading: true });
        let response = await Server.forums.getForums();
        
        if (response.success) {
          forums = response.forums;
          await Server.forums.setForumsCache(forums);
        } else {
          this.setState({ loading: false });
          return;
        }
      }

      // Sort forums by title
      forums.sort((a: any, b: any) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });

      // Filter out forums where forum.hidden is true
      forums = forums.filter((forum: any) => !forum.hidden);

      this.setState({ 
        forums, 
        loading: false,
        selectedForumId: forums.length > 0 ? forums[0].id : ''
      });
    } catch (error) {
      console.error('Error loading forums:', error);
      this.setState({ loading: false });
    }
  }

  onCancel() {
    this.props.onClose();
  }

  onConvert() {
    if (this.state.selectedForumId) {
      this.props.onConvert(this.state.selectedForumId);
    }
  }

  onForumChange(event: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({ selectedForumId: event.target.value });
  }

  render() {
    return (
      <Modal 
        title="Convert to Forum Topic" 
        width="400px"
        onClose={() => this.onCancel()}
      >
        <div style={{ paddingTop: '10px' }}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', textAlign: 'left' }}>
              Select Forum:
            </label>
            <select 
              value={this.state.selectedForumId}
              onChange={this.onForumChange.bind(this)}
              disabled={this.state.loading}
              style={{ width: '100%', boxSizing: 'border-box' }}
            >
              {this.state.loading ? (
                <option>Loading...</option>
              ) : (
                this.state.forums.map((forum: any) => (
                  <option key={forum.id} value={forum.id}>
                    {forum.title}
                  </option>
                ))
              )}
            </select>
          </div>
          
          <div style={{ marginBottom: '15px', fontSize: '0.9em' }}>
            After saving the new forum topic, no more replies to this activity post will be allowed.
          </div>
        
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button 
              onClick={() => this.onConvert()}
              disabled={!this.state.selectedForumId || this.state.loading}
            >
              Convert
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConvertToForumModal; 